import {duplicateSvg as Icon__small__duplicateSvg} from '../Icon__small/Icon__small--duplicate.js';
import {duplicateSvg as Icon__xsmall__duplicateSvg} from '../Icon__xsmall/Icon__xsmall--duplicate.js';

export var duplicate = {
  name: 'duplicate',
  category: 'icon',
  colorable: true,
  svg: Icon__small__duplicateSvg,
  alt: {
    Icon__small: Icon__small__duplicateSvg,
    Icon__xsmall: Icon__xsmall__duplicateSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
